import adjustment from '@/api/payment-adjustment'
import invoice from '@/api/invoice'
import moment from 'moment'
import { isEmpty } from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM (state, date) {
    state.date_from = date
  },
  SET_DATE_TO (state, date) {
    state.date_to = date
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return adjustment.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store (context, data) {
    return adjustment.store(data)
  },

  update (context, { id, data }) {
    return adjustment.update(id, data)
  },
  destroy (context, { id, data }) {
    return adjustment.destroy(id, data)
  },
  async find (context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await adjustment.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getInvoicePaid (context, attributes) {
    return invoice.get({
      params: attributes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  printPdf (context, id) {
    return adjustment.pdf(id)
  },
  formViewModel (context, attributes = {}) {
    return adjustment.formViewModel({
      params: attributes
    })
  }
}
